import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../Components/Header";
import HeroSection from "./Hero";
import ForWhom from "./Compliance";
import Business from "./BuildingTrust";
import Benefits from "./Benefits";

import Footer from "../Components/Footer";
import CTASection from "../AboutUs/CtaSection";
 
function TennetHome() {
  const location = useLocation();
  const businessRef = useRef(null);
  const forWhomRef = useRef(null);

  // Scroll ke bagian yang ditentukan setelah komponen dimuat
  useEffect(() => {
    if (location.state && location.state.section) {
      const { section } = location.state;
      const ref = section === "business" ? businessRef : forWhomRef;
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.state]);

  return (
    <div>
      <Header businessRef={businessRef} forWhomRef={forWhomRef} />
      <main>
        <HeroSection />
        <Business />
        <ForWhom />
        <Benefits />

         <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default TennetHome;
